import {gsap} from "gsap";
import {DasUBoot} from "../DasUBoot";
import {DasUBootGameAssets} from "../DasUBootGameAssets";
import {DasUBootReelsView} from "../reels/DasUBootReelsView";
import {DasUBootStatics} from "../utils/DasUBootStatics";

/**
 * Created by jonas on 2021-03-08.
 */

export class ReelAvalancheAttention extends PIXI.Container{

    private plate:PIXI.Sprite;
    private light:PIXI.Sprite;
    private loop:gsap.core.Tween;
    private movement:number;

    constructor() {
        super();

        this.plate = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.AVALANCHE_ATTENTION)[0]);
        this.plate.anchor.set(0.5,0.5);
        this.plate.scale.set(12,10);
        this.plate.alpha = 0.5;
        this.plate.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(this.plate);

        this.light = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.AVALANCHE_ATTENTION)[0]);
        this.light.anchor.set(0.5,0.6);
        this.light.scale.set(5,15);
        this.light.alpha = 0.5;
        this.light.blendMode = PIXI.BLEND_MODES.ADD;
        this.movement = this.light.width + DasUBootStatics.symbolWidth * 3;
        this.light.x = -this.movement;

        this.addChild(this.light);
        this.alpha = 0;

        this.loop = gsap.fromTo(this.light, {x:-this.movement}, {x:this.movement, duration:0.8, ease:"none", repeat:-1, yoyo:false});
        this.loop.pause(0.2);
    }

    public show(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline({onStart:()=>this.startLoop()});
        tl.add(gsap.to(this, {duration:duration, alpha:1}));
        return tl;
    }


    public hide(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:()=>this.stopLoop()});
        tl.add(gsap.to(this, {duration:duration, alpha:0}));
        return tl;
    }

    private startLoop() {
        this.loop.play();
    }

    private stopLoop() {
        this.loop.pause();
    }
}